export const UNAUTHENTICATED_LANGUAGE_KEY = "unauthenticated-language";

/** Norwegian translations exist under 'nb', so other Norwegian codes need mapping. */
const languageMappings: Record<string, string> = {
  no: "nb",
  nn: "nb",
};

export function saveUnauthenticatedLanguage(locale: string): void {
  localStorage.setItem(UNAUTHENTICATED_LANGUAGE_KEY, locale);
}

export function loadUnauthenticatedLanguage(): string | null {
  return localStorage.getItem(UNAUTHENTICATED_LANGUAGE_KEY);
}

export function detectBrowserLanguage(): string {
  let result = "en";

  const browserLanguage =
    navigator.language ||
    (navigator as Navigator & { userLanguage?: string }).userLanguage;

  if (browserLanguage) {
    result = browserLanguage.split("-")[0];
  }

  return languageMappings[result] || result;
}
